// extracted by mini-css-extract-plugin
export default {"label":"label--dedab8","content-block":"content-block--4a84ff","contentBlock":"content-block--4a84ff"};